export default __webpack_public_path__ + "static/media/tick.221df786.svg";